import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, Navigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { RiDeleteBin6Line } from "react-icons/ri";

import { PrimaryButton } from "../../components/others/ButtonPrimary";
import FormBuilder from "../../components/others/FormBuilder";
import { useFetchOneWithStatus } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import { formatHookFormValuesToSaveMedicalForm } from "../../utils/formFormater";
import { CLOSE } from '../../constants/routes';
import StyledWrapper from "./style";
import { DATAJSON } from "./json/declarationV1";
import { SecundaryButton } from "../../components/others/ButtonSecundary";

// TODO: Make this a isolated component
type ClosePageProps = WithChildren & {};
const ClosePage = ({ children }: ClosePageProps) => {
  const [redirect, setRedirect] = useState(false);

  if (redirect) return <Navigate to={CLOSE} />
  return (
    <div>
      {children}
      <div className="mt-4">
        <PrimaryButton
          text="Salir"
          type="button"
          styles={'font-bold text-white mt-16 bg-red-500'}
          onClick={() => setRedirect(true)}
        />
      </div>
    </div>
  );
};

export default function Declaration() {
  const sigCanvas: any = useRef({});
  const [signature, setSignature] = useState('');
  const [showNoSignatureError, setShowNoSignatureError] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<SubmitStatusTypes>('IDLE');
  const [submitDeclarationError, setSubmitDeclarationError] = useState<'NONE' | 'CONFLICT' | 'UNKNOWN'>('NONE');
  const LavorisInstance = LavorisService.getInstance();
  const { id } = useParams();
  const fetched = useFetchOneWithStatus<any>(`declaration/empty-form/${id}`);
  const [personalData, setPersonalData] = useState<any | undefined>()

  const [confirmationDialog, setConfirmationdialog] = useState(false)
  const formMethods = useForm({ mode: "all" });

  const { handleSubmit } = formMethods;
  //console.log(fetched.data)
  const onSubmit = async (formValues: any) => {
    if (!signature) {
      setShowNoSignatureError(true);
      return;
    }

    const jsonToSave = formatHookFormValuesToSaveMedicalForm(
      fetched.data.json,
      formValues,
    );
    const declaration = {
      form: jsonToSave,
      signature
    };

    try {
      if (!id) return;
      setSubmitStatus('SUBMITTING');
      await LavorisInstance.LegalServices.saveDeclaration(id, declaration);
      setSubmitStatus('SUBMITTED');
    } catch (error: any) {
      const { statusCode } = error.response.data;

      if (statusCode === 409)
        setSubmitDeclarationError('CONFLICT');

      setSubmitStatus('ERROR');
    }
  };

  const toDataURL = () => {
    if (!sigCanvas.current) return;

    const trimmed = sigCanvas.current.getTrimmedCanvas();
    setSignature(trimmed.toDataURL());
    setShowNoSignatureError(false);
  };

  const clearSignatureCanvas = () => {
    sigCanvas.current.clear();
    setSignature('');
  };



  const getPersonalData = async () => {
    const formId = id || "";
    const data = await LavorisInstance.Common.getOne(`declaration/form`, formId)
    setPersonalData(data)
  }

  useEffect(() => {
    const getData = async () => {
      await getPersonalData()
    }
    getData()
  }, [])

  if (submitStatus !== 'IDLE' && submitStatus !== 'SUBMITTING') {
    return (
      <>
        <StyledWrapper.Header>
          <div className="ml-5">
            <img src="/images/LogoGrande.svg" alt="Logo Lavoris" />
          </div>
        </StyledWrapper.Header>

        <StyledWrapper.Back>
          <StyledWrapper.Card>
            <div className="text-center text-xl font-bold text-red-500">
              {
                submitStatus === 'SUBMITTED' ?
                  <ClosePage>
                    <p>Declaración Jurada firmada y guardada correctamente</p>
                  </ClosePage> :
                  submitDeclarationError === 'CONFLICT' ?
                    <ClosePage>
                      <p>Su Declaración Jurada ya fue completada</p>
                    </ClosePage> :
                    <p>Error guardando Declaración Jurada</p>

              }
            </div>
          </StyledWrapper.Card>
        </StyledWrapper.Back>
      </>
    );
  }


  if (fetched.status !== 'FETCHED') {
    if (fetched.status === 'IDLE') return null;

    return (
      <>
        <StyledWrapper.Header>
          <div className="ml-5">
            <img src="/images/LogoGrande.svg" alt="Logo grande Lavoris" />
            <p className="text-white">Portal de Clientes</p>
          </div>
        </StyledWrapper.Header>

        <StyledWrapper.Back>
          <StyledWrapper.Card>
            <div className="text-center text-xl font-bold text-red-500">
              {
                fetched.status === 'CONFLICT' ?
                  <ClosePage>
                    <p>Su Declaración Jurada ya fue completada</p>
                  </ClosePage> :
                  null
              }
              {
                fetched.status === 'FETCHING' ?
                  <p>Recuperando su Declaración Jurada</p> :
                  null
              }
              {
                fetched.status === 'NOT_FOUND' ?
                  <ClosePage>
                    <p>Declaración Jurada no encontrada</p>
                  </ClosePage> :
                  null
              }
              {
                fetched.status === 'UNKNOWN' ?
                  <p>Hubo un error al intentar recuperar su Declaración Jurada</p> :
                  null
              }
            </div>
          </StyledWrapper.Card>
        </StyledWrapper.Back>
      </>
    );
  }

  return (
    <>
      <StyledWrapper.Header>
        <div className="ml-5">
          <img src="/images/LogoGrande.svg" alt="Logo grande Lavoris" />
          <p className="text-white">Portal de Clientes</p>
        </div>
      </StyledWrapper.Header>

      <StyledWrapper.Back>
        <StyledWrapper.Card>
          <StyledWrapper.Tittle>Declaración Jurada</StyledWrapper.Tittle>
          <StyledWrapper.SubtitleBox>
            <img src="/images/Timer.svg" alt="" />
            <p>Tiempo de respuesta: 6 minutos</p>
          </StyledWrapper.SubtitleBox>
          <form onSubmit={handleSubmit(onSubmit)}>
            <StyledWrapper.FormContainer>
              {fetched.data.json.length && (
                <FormBuilder
                 // json={JSON.stringify(DATAJSON)}
                  json={JSON.stringify(fetched.data.json)}
                  formMethods={formMethods}
                  personalData={personalData}
                  lockPersonalFields
                />
              )}
              <label className="mt-16 mb-6">
                <input
                  className="rounded border-red-500 mr-2"
                  type="checkbox"
                  required
                />
                Declaro que todos los datos mencionados en esta declaración
                jurada son verdaderos.
              </label>
              <p>Firma</p>
              <SignatureCanvas
                ref={sigCanvas}
                onEnd={toDataURL}
                penColor="red"
                canvasProps={{
                  style: {
                    border: '1px solid rgb(208, 208, 208)',
                    borderRadius: '5px'
                  }
                }}
              />
              <div onClick={clearSignatureCanvas} className="flex justify-end items-center cursor-pointer">
                <RiDeleteBin6Line className="text-[#DF6865] lg:h-10 lg:w-10" />
                <p className="text-red-500">Borrar firma</p>
              </div>
              {showNoSignatureError &&
                <span className="text-red-600 font-bold">Firmar esta Declaración Jurada es obligatorio*</span>
              }
              {
                confirmationDialog && (
                  <div className="w-full">
                    <span className="text-red-600 font-bold w-auto">Una vez enviado el formulario los datos no se podrán modificar. ¿Desea confirmar?</span>
                    <div className="flex flex-col md:flex-row justify-between w-full">
                      <SecundaryButton
                        type="button"
                        text="No"
                        styles={`font-bold text-black mt-16 `}
                        onClick={() => setConfirmationdialog(false)}
                      />
                      <PrimaryButton
                        type="submit"
                        text={submitStatus === 'SUBMITTING' ? "Guardando..." : "Si"}
                        styles={`font-bold text-white mt-16 ${submitStatus === 'SUBMITTING' ? 'bg-red-200' : 'bg-red-500'}`}

                      />
                    </div>
                  </div>
                )
              }

              {
                !confirmationDialog && (
                  <PrimaryButton
                    type="button"
                    text={"Finalizar"}
                    onClick={() => setConfirmationdialog(true)}
                    styles={`font-bold text-white mt-16 bg-red-500`}
                  // disabled={submitStatus === 'SUBMITTING'}
                  />
                )
              }

            </StyledWrapper.FormContainer>
          </form>
        </StyledWrapper.Card>
      </StyledWrapper.Back>
    </>
  );
}
